const _ = require('lodash');

const createBaseUserActionEvent = ({
    targetLocale,
    sourceInfo: { gig, user, ...page }
}) => ({
    'user_id': _.get(user, 'id'),
    'Gig Id': _.get(gig, 'id'),
    'Page': _.get(page, 'name'),
    'Component': _.get(page, 'component.name'),
    'User Locale': targetLocale
});

module.exports = {
    createBaseUserActionEvent
};
